import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _replace from 'lodash/replace';
import _trim from 'lodash/trim';

export const PLACEHOLDER_FIELD_EMAIL = '+ Ex. john@smith.com';
export const PLACEHOLDER_FIELD_PASSWORD = 'Password';
export const PLACEHOLDER_FIELD_CURRENT_PASSWORD = 'Current Password';
export const PLACEHOLDER_FIELD_NEW_PASSWORD = 'New Password';
export const PLACEHOLDER_FIELD_CONFIRM_PASSWORD = 'Confirm Password';

export const PLACEHOLDER_FIELD_TO = 'To: ';
export const PLACEHOLDER_FIELD_NAME = '+ Ex. John Smith';
export const PLACEHOLDER_FIELD_NAMES = '+ Ex. John Smith; Mary Smith';
export const PLACEHOLDER_FIELD_FIRST_NAME = '+ Ex. John';
export const PLACEHOLDER_FIELD_MIDDLE_NAME = '+ Ex. Lee';
export const PLACEHOLDER_FIELD_LAST_NAME = '+ Ex. Smith';

export const PLACEHOLDER_FIELD_COMPANY_NAME = '+ Ex. Your company, Inc';
export const PLACEHOLDER_FIELD_INDUSTRY = '+ Ex. Healthcare';
export const PLACEHOLDER_FIELD_COMPANY_SIZE = '+ Ex. 1 to 10 Employees';
export const PLACEHOLDER_FIELD_YEAR_FOUNDED = '+ Ex. 2015';
export const PLACEHOLDER_FIELD_COMPANY_BIO = '+ Ex. Company Bio';
export const PLACEHOLDER_FIELD_BENEFITS_SUMMARY = '+ Ex. Benefits Summary';

export const PLACEHOLDER_FIELD_GENDER = '+ Ex. Male';
export const PLACEHOLDER_FIELD_RACE = '+ Ex. American Indian';

export const PLACEHOLDER_FIELD_PHONE = 'Ex. +1 301 567 9544'; //'Ex. +90 123 456 89 10';
export const PLACEHOLDER_FIELD_STREET1 = '+ Ex. 123 Main St.';
export const PLACEHOLDER_FIELD_STREET2 = '+ Ex. Suite 328';
export const PLACEHOLDER_FIELD_COUNTRY = '+ Ex. United States';
export const PLACEHOLDER_FIELD_STATE = '+ Ex. California';
export const PLACEHOLDER_FIELD_CITY = '+ Ex. Los Angeles';
export const PLACEHOLDER_FIELD_ZIP_CODE = '+ Ex. 94103';

export const PLACEHOLDER_FIELD_JOB_ID_REQUISITION_NUMBER = '+ Ex. A12345678';
export const PLACEHOLDER_FIELD_JOB_TITLE = '+ Ex. Account Manager';
export const PLACEHOLDER_FIELD_JOB_DESCRIPTION = '+ Ex. This job entails the following...';
export const PLACEHOLDER_FIELD_EMPLOYMENT_TYPE_SINGLE = '+ Ex. Full Time';
export const PLACEHOLDER_FIELD_EMPLOYMENT_TYPE = '+ Ex. Full Time, Part Time';
export const PLACEHOLDER_FIELD_YEARS_OF_EXPERIENCE = '+ Ex. 3+ Years';
export const PLACEHOLDER_FIELD_OCCUPATION = '+ Ex. Software Developer, Electrician';
export const PLACEHOLDER_FIELD_SKILLSET = '+ Ex. Problem Solving, Communication';
export const PLACEHOLDER_FIELD_TELEWORK = '+ Ex. Complete Telework';

export const PLACEHOLDER_FIELD_CURRENCY = '+ Ex. USD';
export const PLACEHOLDER_FIELD_PAY_FREQUENCY = '+ Ex. Yearly';
export const PLACEHOLDER_FIELD_SALARY_RANGE = '+ Ex. $20,000+';
export const PLACEHOLDER_FIELD_RATE_EXACT = '+ Ex. $20,000 OR $25';
export const PLACEHOLDER_FIELD_RATE_MIN = '+ Ex. $1 (min)';
export const PLACEHOLDER_FIELD_RATE_MAX = '+ Ex. $1,000,000 (max)';
export const PLACEHOLDER_FIELD_RATE_PLUS = 'Ex. $1 +';
export const PLACEHOLDER_FIELD_RATE_MAX2 = '+ Ex. $90,000 (max)';

export const PLACEHOLDER_FIELD_EDUCATION = '+ Ex. High School Diploma';
export const PLACEHOLDER_FIELD_OTHER_EDUCATION = '+ Ex. Registered Nurse Board Certified (RN-BC)';

export const PLACEHOLDER_FIELD_ABOUT_ME = 'I am...';
export const PLACEHOLDER_FIELD_RESUME_TITLE = 'Ex. Software Developer, Electrician';

export const PLACEHOLDER_FIELD_DATE_FORMAT = 'Select a format';
export const PLACEHOLDER_FIELD_ADDITIONAL_FEEDBACK = 'Please tell us how we can improve our platform and service';

export const PLACEHOLDER_FIELD_FACEBOOK_URL = 'Ex. https://www.facebook.com/youraccount';
export const PLACEHOLDER_FIELD_LINKEDIN_URL = 'Ex. https://www.linkedin.com/youraccount';
export const PLACEHOLDER_FIELD_YOUTUBE_URL = 'Ex. https://www.youtube.com/youraccount';
export const PLACEHOLDER_FIELD_INSTAGRAM_URL = 'Ex. https://www.instagram.com/youraccount';
export const PLACEHOLDER_FIELD_TWITTER_URL = 'Ex. https://www.twitter.com/youraccount';
export const PLACEHOLDER_FIELD_WEBSITE_URL = 'Ex. https://www.yourwebsite.com';
export const PLACEHOLDER_FIELD_TIKTOK_URL = 'Ex. https://vm.tiktok.com/youraccount';
export const PLACEHOLDER_FIELD_GITHUB_URL = 'Ex. https://github.com/youraccount';

export const PLACEHOLDER_SEARCH_EMPLOYERS = 'Search Employers...';
export const PLACEHOLDER_SEARCH_BY_COMPANY_NAME = 'Search by Company Name';
export const PLACEHOLDER_SEARCH_JOB = 'Search Job';
export const PLACEHOLDER_SEARCH_BY_JOB_TITLE = 'Search by Job Title';
export const PLACEHOLDER_SEARCH_BY_JOB_TITLE_JOB_ID_NUMBER = 'Search by Job Title or ID#';
export const PLACEHOLDER_SEARCH_BY_JOB_TITLE_SKILLSET_KEYWORDS = 'Search by Job Title, Skillset(s), or Keywords';
export const PLACEHOLDER_SEARCH_BY_OCCUPATION_SKILLSET_KEYWORDS = 'Search by Occupation, Skillset(s), or Keywords';
export const PLACEHOLDER_SEARCH_JOB_TITLES = 'Search Job Titles';
export const PLACEHOLDER_SEARCH_OCCUPATIONS = 'Search Occupations';
export const PLACEHOLDER_SEARCH_BY_LOCATION = 'Search by Location';
export const PLACEHOLDER_SEARCH_NAME = 'Search Name';

export const PLACEHOLDER_JOB_TITLE_SKILLSET_KEYWORDS = 'Job Title, Skillset(s), or Keywords';
export const PLACEHOLDER_OCCUPATION_SKILLSET_KEYWORDS = 'Occupation, Skillset(s), or Keywords';
export const PLACEHOLDER_LOCATION = 'Location';

export const PLACEHOLDER_FIELD_SETTINGS_USERS_INVITE = 'Enter email address to send invitation';
export const PLACEHOLDER_FIELD_SETTINGS_USERS_INVITE_OUT_OF_SEATS = 'You have run out of vacant seats';

export const NO_OPTIONS_TEXT_GENDER = 'Type and select gender';
export const NO_OPTIONS_TEXT_OCCUPATION = 'Type and select occupation(s)';
export const NO_OPTIONS_TEXT_SKILLSET = 'Type and select skillset(s)';
export const NO_OPTIONS_TEXT_OTHER_EDUCATION = 'Type and select other education';
export const NO_OPTIONS_TEXT_INDUSTRY = 'Type and select industry';

// export const PLACEHOLDER_FIELD_ = '+ Ex. XXXXXXXXXXXXXX'

// export const PLACEHOLDER_FIELD_ = '+ Ex. XXXXXXXXXXXXXX'

export const getLovPlaceholderFromLov = (lov, defaultPlaceholder) => {
    const label = _get(lov, '[0]');
    return label ? `+ Ex. ${label}` : defaultPlaceholder;
};

export const getStateLovPlaceholder = (lov, defaultPlaceholder) => {
    const label = _get(lov, '[0].name');
    return label ? `+ Ex. ${label}` : defaultPlaceholder;
};

export const getCityLovPlaceholder = (lov, defaultPlaceholder) => {
    const label = _get(lov, '[0].name');
    return label ? `+ Ex. ${label}` : defaultPlaceholder;
};

export const getIsExactRatePlaceholder = currencySymbol => {
    let placeholderText = PLACEHOLDER_FIELD_RATE_EXACT;
    if (!_isNil(currencySymbol) && _trim(currencySymbol) !== '') {
        placeholderText = _replace(placeholderText, '$', currencySymbol);
    }
    return placeholderText;
};

export const getRateMinPlaceholder = currencySymbol => {
    let placeholderText = PLACEHOLDER_FIELD_RATE_MIN;
    if (!_isNil(currencySymbol) && _trim(currencySymbol) !== '') {
        placeholderText = _replace(placeholderText, '$', currencySymbol);
    }
    return placeholderText;
};

export const getRateMaxPlaceholder = currencySymbol => {
    let placeholderText = PLACEHOLDER_FIELD_RATE_MAX;
    if (!_isNil(currencySymbol) && _trim(currencySymbol) !== '') {
        placeholderText = _replace(placeholderText, '$', currencySymbol);
    }
    return placeholderText;
};
